var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "swiper",
    { staticClass: "swiper", attrs: { options: _vm.swiperOption } },
    [
      _c("swiper-slide", [
        _c("div", { staticClass: "comment" }, [
          _c(
            "div",
            [
              _vm._v(
                "O " +
                  _vm._s(_vm.SISTEMA) +
                  " tem sido uma ferramenta muito importante para promoção da regularização fundiária no Estado,\n a proximidade e facilidade de acesso a população foi o ponto chave\n para se alcançar grandes resultados em tão pouco tempo. Acreditamos\n que o " +
                  _vm._s(_vm.SISTEMA) +
                  " é a nova chave para entregarmos um produto atual e com\n seguranca jurídica e assim desenvolvermos um diálogo mais fácil não\n só com o interessado, como também com outros órgãos regularizadores."
              ),
              _c("br"),
              _c("br"),
              _vm._v("Mariceli Moura"),
              _c("br"),
              _c("br"),
              _c("rate", { attrs: { length: 5, value: 5, readonly: true } })
            ],
            1
          )
        ])
      ]),
      _c("swiper-slide", [
        _c(
          "div",
          { staticClass: "comment" },
          [
            _vm._v(
              "O " +
                _vm._s(_vm.SISTEMA) +
                " se alinha às principais demandas de um mundo tecnológico. Não só permite iniciar e analisar processos por meio de qualquer\n dispositivo com acesso à internet, como sua interface auxilia na\n compreensão dos passos a serem seguidos pelo interessado e pelo\n servidor público. Além disso, cria uma possibilidade de interação\n quase imediata, por meio de troca de mensagens. O " +
                _vm._s(_vm.SISTEMA) +
                " tem a virtude\n aproximar o cidadão do " +
                _vm._s(_vm.ORGAO) +
                "."
            ),
            _c("br"),
            _c("br"),
            _vm._v("João Olegário"),
            _c("br"),
            _c("br"),
            _c("rate", { attrs: { length: 5, value: 5, readonly: true } })
          ],
          1
        )
      ]),
      _c("swiper-slide", [
        _c(
          "div",
          { staticClass: "comment" },
          [
            _vm._v(
              "O " +
                _vm._s(_vm.SISTEMA) +
                " é a resposta eficiente para o caminho de uma regularização fundiária rápida e extremamente eficaz. Trazer o campo para a cidade\n agora é muito fácil, antigamente precisávamos viajar do interior para\n a capital e protocolar todos os documentos necessários para o pedido de\n regularização fundiária, com a criação de um sistema moderno o futuro\n chegou e agora em poucos cliques conseguimos carregar todos os dados e\n acompanhar o andamento do processo em tempo real. O " +
                _vm._s(_vm.ORGAO) +
                " mostra-se atual\n e atuante em torno das demandas fundiárias e necessidades advindas daqueles\n que trabalham no campo bem como dos que atuam nos processos administrativos."
            ),
            _c("br"),
            _c("br"),
            _vm._v("Alexandre Gouvêa"),
            _c("br"),
            _c("br"),
            _c("rate", { attrs: { length: 5, value: 5, readonly: true } })
          ],
          1
        )
      ]),
      _c("swiper-slide", [
        _c(
          "div",
          { staticClass: "comment" },
          [
            _vm._v(
              "Só posso dizer o quanto estou feliz em acompanhar a evolução e melhoramento dos serviços prestados pelo " +
                _vm._s(_vm.ORGAO) +
                " à sociedade. A plataforma " +
                _vm._s(_vm.SISTEMA) +
                " trouxe\n inovação tecnológica e celeridade processual. O sistema é de fácil manuseio,\n tanto para o protocolo de pedidos e recebimento de notificações. Essa interação\n possibilita o acompanhamento diário dos processos independente da sua localização\n física bastando ao advogado acesso a internet no módulo " +
                _vm._s(_vm.SISTEMA) +
                " on-line."
            ),
            _c("br"),
            _c("br"),
            _vm._v("Naire Rei"),
            _c("br"),
            _c("br"),
            _c("rate", { attrs: { length: 5, value: 5, readonly: true } })
          ],
          1
        )
      ]),
      _c("div", {
        staticClass: "swiper-button-prev",
        attrs: { slot: "button-prev" },
        slot: "button-prev"
      }),
      _c("div", {
        staticClass: "swiper-button-next",
        attrs: { slot: "button-next" },
        slot: "button-next"
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c4ba2aba", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c4ba2aba","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/portal/publico/components/home/TheComments.vue
// module id = null
// module chunks = 